import React, { useState } from 'react';
import axios from 'axios';
import config from '../../../../../../application/config/config';
import { getUserSession } from '../../../../../util/core/Session';
import Toast from '../../Toast/Toast';

const FileUpload = React.forwardRef((props, ref) => {
    const [file, setFile] = useState(props.file ? props.file : '');
    const [value, setValue] = useState('');
    const fileExtension = props.file.split('.').pop();
    const extensionImages = ['jpeg', 'jpg', 'png'];
    const isImage = extensionImages.includes(fileExtension.toLowerCase());
    const [link, setLink] = useState(props.file ? config.endpoints.backend + props.file : '');

    const handleChange = async (value) => {
        const session = getUserSession();
        if(props.disabled){
            Toast.error(`Upload de arquivo desabilitado.`);
            return;
        } else if (value.target.files.length > 0) {
            const size = value.target.files[0].size / 1000000;
            const limitSize = props.limitFileSize;
            if(size > limitSize){
                Toast.error(`O arquivo não pode ser maior que ${limitSize} MB(s).`);
                return;
            }
            const data = new FormData();
            const token = session.token;
            const path = config.endpoints.backend + 'core/fileupload/upload';
            const configHeader = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            };
            data.append('file', value.target.files[0]);
            data.append('token', token);
            data.append('path', props.path);

            props.beforeUpload && props.beforeUpload();
            axios.post(path, data, configHeader).then((res) => {
                const uploadedFile = res.data.files[0];
                props.onUpload && props.onUpload(props.name, uploadedFile);
                const newFileExtension = uploadedFile.split('.').pop();
                const newIsImage = extensionImages.includes(newFileExtension.toLowerCase());
                setFile(uploadedFile);
                setLink(config.endpoints.backend + uploadedFile);
                setValue('');
            }).catch(error => console.error(error));
        }
    };

    const clickRemove = async () => {
        setFile('');
        props.onRemove && props.onRemove(props.name, '');
    };

    return (
        <div style={{ marginTop: 10 }} ref={ref}>
            {!file && !props.disabled && (
                <div>
                    <label className="btn btn-primary">
                        <input
                            id="my-file-selector"
                            className="d-none"
                            type="file"
                            name={props.name}
                            onChange={handleChange}
                            accept={props.accept}
                            value={value}
                            autoFocus={props.autoFocus ? true : false}
                        />
                        {props.titleButton}
                    </label>
                    {props.error && (
                        <div
                            className="error invalid-feedback"
                            style={{ display: 'inline', width: '100%', marginLeft: '10px' }}>
                            {props.error}
                        </div>
                    )}
                </div>
            )}
            {file && !isImage && (
                <div>
                    <a target="_blank" href={link}>Download</a>
                    &nbsp;&nbsp;<span onClick={clickRemove} className="required" style={{ cursor: 'pointer' }}><strong>X</strong></span>
                    {props.error && (
                        <div
                            className="error invalid-feedback"
                            style={{ display: 'inline', width: '100%', marginLeft: '10px' }}>
                            {props.error}
                        </div>
                    )}
                </div>
            )}
            {file && isImage && (
                <div style={{ width: "100px" }}>
                    <a target="_blank" href={link}>
                        <img style={{ width: '100px' }} src={link} alt="Uploaded" />
                    </a>
                    {!props.disabled && (
                        <div onClick={clickRemove} className="required" style={{ cursor: 'pointer', textAlign: 'center', marginTop: '5px' }}>remover</div>
                    )}
                    {props.error && (
                        <div
                            className="error invalid-feedback"
                            style={{ display: 'inline', width: '100%', marginLeft: '10px' }}>
                            {props.error}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
});

FileUpload.defaultProps = {
    onChange: () => { },
    onUpload: () => { },
    beforeUpload: () => { },
    onRemove: () => { },
    path: '',
    accept: "media_type",
    titleButton: 'Anexar',
    file: '',
    limitFileSize: 5,
    disabled: false
};

export default FileUpload;
